'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dI$002dP$0024$0024anon$002477 from "./presto.types$-I-P$$anon$77.js";
var $p;
/** @constructor */
function $c_Lpresto_types$IP$() {
  this.c8N = null;
  this.c8O = false;
  this.c8L = null;
  this.c8M = false;
  this.c8J = null;
  this.c8K = false;
  this.c8P = null;
  this.c8Q = false;
}
export { $c_Lpresto_types$IP$ as $c_Lpresto_types$IP$ };
$p = $c_Lpresto_types$IP$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$IP$;
/** @constructor */
function $h_Lpresto_types$IP$() {
}
export { $h_Lpresto_types$IP$ as $h_Lpresto_types$IP$ };
$h_Lpresto_types$IP$.prototype = $p;
$p.cJN = (function() {
  if ((!this.c8O)) {
    this.c8N = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8O = true;
  }
  return this.c8N;
});
$p.csV = (function() {
  if ((!this.c8M)) {
    this.c8L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8M = true;
  }
  return this.c8L;
});
$p.cIL = (function() {
  if ((!this.c8K)) {
    this.c8J = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c8K = true;
  }
  return this.c8J;
});
$p.cK6 = (function() {
  if ((!this.c8Q)) {
    this.c8P = new $j_presto$002etypes$0024$002dI$002dP$0024$0024anon$002477.$c_Lpresto_types$IP$$anon$77(this);
    this.c8Q = true;
  }
  return this.c8P;
});
var $d_Lpresto_types$IP$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$IP$, "presto.types$IP$", ({
  a0D: 1,
  D: 1
}));
export { $d_Lpresto_types$IP$ as $d_Lpresto_types$IP$ };
var $n_Lpresto_types$IP$;
function $m_Lpresto_types$IP$() {
  if ((!$n_Lpresto_types$IP$)) {
    $n_Lpresto_types$IP$ = new $c_Lpresto_types$IP$();
  }
  return $n_Lpresto_types$IP$;
}
export { $m_Lpresto_types$IP$ as $m_Lpresto_types$IP$ };
//# sourceMappingURL=presto.types$-I-P$.js.map
